import React, { Component } from "react";
import { Row, Col, Form, FormGroup, ControlLabel } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import { connect } from 'react-redux';
import Alert from "sweetalert-react";
import { ButtonStyle } from "../Styles";
import { TextField, SelectField } from "../Shared/FormHelpers";
import { createContactMessage } from "../../redux/middleware/contact";
import {
  Container,
  DescriptionLabel,
  EditorWrapper,
} from "./Styles/ContactForm.styles";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = this.initFormData();
  }

  componentWillReceiveProps(nextProps) {
    const { contact, notify } = this.props;
    if (
      contact.pending &&
      nextProps.contact &&
      !nextProps.contact.pending &&
      nextProps.contact.contact
    ) {
      notify(
        "success",
        "Your message was sent successfully. Sit tight and a member of our team will contact you soon."
      );
      this.initFormData();
    }
  }

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    var emailFlag = EmailValidator.validate(value);
    if (emailFlag) {
      this.state.applyEmail = value;
    } else {
      this.state.url = value;
    }
    this.setState({ [name]: value });
  };

  handleError = (type, message) => this.props.notify(type, message);

  flashMessage = (message, status) => {
    this.setState({ messages: [{ message: message, status: status }] });
    setTimeout(this.setState({ flash: null }), 2000);
  };

  handleSubmit = () => {
    this.validate() && this.props.createContactMessage(this.formData());
  };

  validate = () => {
    let errors = [];
    if (this.state.contactType === undefined || this.state.contactType === "") {
      errors.push({
        field: "contactType",
        message: "ContactType can't be blank",
      });
    }
    if (this.state.name === undefined || this.state.name === "") {
      errors.push({ field: "name", message: "Name can't be blank" });
    }
    if (this.state.email === undefined || this.state.email === "") {
      errors.push({ field: "email", message: "Email can't be blank" });
    }

    if (this.state.phone === undefined || this.state.phone === "") {
      errors.push({ field: "phone", message: "Phone can't be blank" });
    }
    if (this.state.company === undefined || this.state.company === "") {
      errors.push({ field: "company", message: "Company can't be blank" });
    }
    if (this.state.comment === undefined || this.state.comment === "") {
      errors.push({ field: "comment", message: "Comment can't be blank" });
    }

    errors
      .map((error) => error.message)
      .forEach((error) => this.handleError("error", error));
    return errors.length === 0;
  };

  formData = () => ({
    name: this.state.name,
    email: this.state.email,
    contact_type: this.state.contactType,
    phone: this.state.phone,
    company: this.state.company,
    comment: this.state.comment,
  });

  initFormData = () => ({
    showList: false,
    value: [],
    name: "",
    email: "",
    contactType: "",
    phone: "",
    company: "",
    comment: "",
    show: false,
  });

  render() {
    const contactType = [
      "Sales",
      "Sourcing Concierge",
      "Recruiting Support",
      "Technical Support",
      "Customer Service",
      "Billing",
      "User Feedback",
    ];
    const messages = [{ message: "Testing", status: "success" }]; // this.state;

    return (
      <Container>
        {
          <Form name="contactForm">
            <section>
              <Row>
                <Col md={12}>
                  <SelectField
                    options={contactType}
                    style={{ background: "initial", height: 54 }}
                    title="Type of Contact"
                    name="contactType"
                    onChange={this.handleChange}
                    value={this.state.contactType}
                    label
                    required
                  />
                </Col>
                <Col sm={6}>
                  <TextField
                    placeholder="Your Name"
                    title="Name"
                    name="name"
                    onChange={this.handleChange}
                    value={this.state.name}
                  />
                </Col>
                <Col sm={6}>
                  <TextField
                    placeholder="Your@email.com"
                    title="Email"
                    name="email"
                    onChange={this.handleChange}
                    value={this.state.email}
                  />
                </Col>
                <Col sm={6}>
                  <TextField
                    placeholder="Phone Number"
                    title="Phone"
                    name="phone"
                    onChange={this.handleChange}
                    value={this.state.phone}
                  />
                </Col>
                <Col sm={6}>
                  <TextField
                    placeholder="Your Company"
                    title="Company"
                    name="company"
                    onChange={this.handleChange}
                    value={this.state.company}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <DescriptionLabel componentClass={ControlLabel}>
                      Comment
                    </DescriptionLabel>
                    <EditorWrapper>
                      <textarea
                        style={{
                          background: "initial",
                          width: "100%",
                          height: 200,
                        }}
                        placeholder="Comment.."
                        name="comment"
                        onChange={this.handleChange}
                        value={this.state.comment}
                      />
                    </EditorWrapper>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={this.handleSubmit}
                  >
                    Send
                  </ButtonStyle>
                </Col>
              </Row>
            </section>
          </Form>
        }
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  contact: state.contact,
});

const mapDispatchToProps = (dispatch) => ({
  createContactMessage: (data) => dispatch(createContactMessage(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm)
